export default __webpack_public_path__ + "static/media/water-mark.43dc1cd4.png";